import React, { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import Navbar from './navbar/index.js';
import { MDTApp } from '../../../../../actions/bootAction.js';
import { IconSet } from '../../../../atoms/mdt-iconset/index.js';
import { sendEventTrackingData } from '../../../../../helpers/commonUtils.js';
import constants from '../../../../../helpers/constants.js';
import './globalNavigation.css';

export const GlobalNavigation = (props) => {
    const [menuOpen, setMenuOpen] = useState(false);
    const [showLevel0, setShowLevel0] = useState(false);

    const trackHamburgerMenuClick = useCallback(
        (flag, fromMenu = true) => {
            if (fromMenu !== true) {
                setMenuOpen(!!flag);

                const eventParamObj = {
                    eventCategory: 'globalHeader',
                    eventAction: menuOpen ? 'openMenu' : 'closeMenu',
                    eventLabel: props.pageName,
                    processLabels: false,
                };
                sendEventTrackingData(eventParamObj);
            }
        },
        [menuOpen, props]
    );

    useEffect(() => {
        trackHamburgerMenuClick();

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [trackHamburgerMenuClick, props]);

    useEffect(() => {
        props.showOverlay(menuOpen);
        setShowLevel0(menuOpen);
    }, [menuOpen]);

    const handleResize = () => {
        if (window.innerWidth >= constants.DESKTOP_WIDTH) {
            setMenuOpen(false);
            setShowLevel0(false);
        }
    };

    const iconProps = {
        name: `${menuOpen ? 'cross' : 'burger'}`,
        icon: `${menuOpen ? 'cross' : 'burger'}`,
    };

    const navMenuProp = {
        t: props.t,
        menuOpen,
        loggedIn: props.loggedIn,
        setMenuOpen,
        showLevel0,
        setShowLevel0,
    };

    return (
        <>
            <button
                type='button'
                className={`${
                    menuOpen ? 'mdttoolbar-hamburger-menu active' : 'mdttoolbar-hamburger-menu'
                }`}
                onClick={() => {
                    setMenuOpen(!menuOpen);
                }}
            >
                <IconSet {...iconProps} />

                {!menuOpen &&
                    !!(props.notificationCount && props.notificationCount.unreadCount > 0) && (
                        <span name='badge' className='badge d-block d-sm-none d-md-none'>
                            {props.notificationCount && props.notificationCount.unreadCount}
                        </span>
                    )}
            </button>

            <Navbar {...navMenuProp} toggleFunc={trackHamburgerMenuClick} />
        </>
    );
};

GlobalNavigation.defaultProps = {
    showOverlay: true,
    focusLockClassName: '',
    offset: -100,
    parentScroll: false,
};

const mapDispatchToProps = (dispatch) => {
    return {
        showOverlay: (data) => dispatch(MDTApp.saveScreenOverlay(data)),
    };
};

export default connect(null, mapDispatchToProps)(GlobalNavigation);
